import unit1 from './unit1';
import nature from './nature';
import animals from './animals';
import adjectives from './adjectives';
import travel from './travel';
import environment from './environment';
import idioms from './idioms';
import report from './report';
import leisure from './leisure';
import collocations from './collocations';

export const VOCABULARY_M10_U1 = [ 
 ...unit1,
 ...nature,
 ...animals,
 ...adjectives,
 ...travel,
 ...environment,
 ...idioms,
 ...report,
 ...leisure,
 ...collocations


];